/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".Card[_ngcontent-%COMP%]{margin-bottom:1rem;display:block}.Card-inner[_ngcontent-%COMP%]{padding:0}legend.Card-title[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start}"];
export { styles as styles };
